import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as brands_actions from "data/brands/actions";
import * as categories_actions from "data/categories/actions";
import * as providers_actions from "data/providers/actions";
import * as products_actions from "data/products/actions";
import * as producttypes_actions from "data/productTypes/actions";

import * as os from "osutil";
import GenderInfo from "components/Formaters/GenderInfo";
import AgeInfo from "components/Formaters/AgeInfo";
import BrandHeader from "components/Brand/BrandHeader";

import Chart from "components/Charts/Chart";

import SegmentList from "components/Lists/SegmentList";
import BrandCategoryStats from "components/Brand/BrandCategoryStats";
import BrandCategoryTargets from "components/Brand/BrandCategoryTargets";
import Paragraphs from "components/Formaters/Paragraphs";
import ReadMore from "components/Formaters/ReadMore";
import AvatarList from "components/Lists/AvatarList";

import ProductGrid from "components/Grid/ProductGrid";
import {
  Page,
  PageSection,
  PageBlock,
  PageHeader,
  PageHeaderImage,
  RightDrawer
} from "components/Page";

class BrandCategoryPage extends Component {
  state = { tab: "summary" };
  static contextTypes = {
    router: PropTypes.object
  };

  tabs = [
    { label: "Översikt", key: "summary" },
    { label: "Statistik", key: "statistics" },
    { label: "Målgrupp", key: "target" },
    { label: "Annonsinformation", key: "adinfo" }
  ];

  handleCancel(id) {
    this.context.router.history.push("/medier");
  }

  handleNav = e => {
    this.setState({ ...this.state, tab: e });
  };

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchCategories();
    this.props.actions.fetchProviders();
    this.props.actions.fetchProducts(); //(this.props.id);
    this.props.actions.fetchProducttypes(); //(this.props.id);
    this.props.actions.fetchBrand(this.props.params.brandid);
  }

  onLogoClick = () => {
    this.context.router.history.push("/media/" + this.props.params.brandid);
  };

  renderStatsCharts = stats => {
    return _.map(stats, (t, key) => {
      const provider = this.props.providers[t.providerid];
      if (!provider) {
        return null;
      }
      return (
        <PageBlock key={key} label={t.name} className="brand_provider">
          {provider.logoUrl && (
            <img alt="Logo" src={provider.logoUrl} title={provider.name} />
          )}
          )}
          <div className="brand_provider__chart">
            <Chart stats={t} />
          </div>
        </PageBlock>
      );
    });
  };

  renderTargetCharts = targets => {
    return _.map(targets, (t, key) => {
      const provider = this.props.providers[t.providerid];
      if (!provider) {
        return null;
      }
      return (
        <PageBlock key={key} label={t.name} className="brand_provider">
          {provider.logoUrl && (
            <img alt="" src={provider.logoUrl} title={provider.name} />
          )}
          <span>{provider.name}</span>
          )}
          <div className="brand_chart">
            <Chart stats={t} />
          </div>
        </PageBlock>
      );
    });
  };

  render() {
    if (!this.props.brand || !this.props.params) {
      return null;
    }
    var headerimage = this.props.brand.bgimageUrl;
    var title = (
      <span>
        {this.props.brand.name} » {this.props.brandcategory.name}{" "}
      </span>
    );

    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Beskrivning">
          <ReadMore height="22em">
            
            <Paragraphs
            boldfirst={true} 
              text={
                this.props.brandcategory.description ||
                this.props.category.description
              }
            />
          </ReadMore>
        </PageBlock>

        <PageBlock label="Målgrupper">
          <AgeInfo item={this.props.brand} label="Ålder" />
          <GenderInfo item={this.props.brand} label="Könsfördelning" />
        </PageBlock>

        {this.props.brandcategory.persons && (
          <PageBlock label="Personer">
            <AvatarList persons={this.props.brandcategory.persons} />
          </PageBlock>
        )}


      </RightDrawer>,
      <header id="hero" key="brand_cat_hero">
        <BrandHeader
          onLogoClick={this.onLogoClick}
          onNav={this.handleNav}
          tabs={this.tabs}
          brand={this.props.brand}
          category={this.props.brandcategory}
        >
          {this.props.brand.segments && (
            <SegmentList segments={this.props.brand.segments} />
          )}
        </BrandHeader>
      </header>,
      <Page key="brand_cat_page" ready={!this.props.pending} className="brand">
        {this.state.tab === "summary" && (
          <PageSection nav="summary">
            <PageBlock label="Produkter">
              <ProductGrid
                brandid={this.props.params.brandid}
                categoryid={this.props.params.categoryid}
              />
            </PageBlock>
          </PageSection>
        )}

        {this.state.tab === "statistics" && (
          <PageSection nav="statistics">
            <BrandCategoryStats stats={this.props.brandcategory.stats} />

            <PageBlock label="Beskrivning">
              <Paragraphs text={this.props.brandcategory.statsdescription} />
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "target" && (
          <PageSection nav="target">
            <BrandCategoryTargets targets={this.props.brandcategory.targets} />

            <PageBlock label="Beskrivning">
              <Paragraphs text={this.props.brandcategory.targetgroup} />
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "adinfo" && (
          <PageSection nav="target">
            <PageBlock label="Annonsinformation">
              <h3>Annonsinformation</h3>
              <Paragraphs text={this.props.brandcategory.adinfo} />
              <h3>Materialinformation</h3>
              <Paragraphs text={this.props.brandcategory.materialinfo} />
            </PageBlock>
          </PageSection>
        )}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (!state.categories.list.data) {
    return {};
  }

  var brand = state.brands.details.data;
  if (!brand) {
    return {};
  }

  var brandcategory = {};
  var category = {};

  if (brand.categories) {
    brandcategory = brand.categories[ownProps.params.categoryid];
    brandcategory.key = ownProps.params.categoryid;
    var _category = state.categories.list.data[brandcategory.categoryid];
    if (_category) {
      var override = os.filter_empty_values(brandcategory);
      category = { ..._category, ...override };
    }
  }

  var s = {
    brand: brand,
    category: category,
    brandcategory: brandcategory,
    providers: state.providers.list.data
  };
  return s;
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...brands_actions,
        ...categories_actions,
        ...providers_actions,
        ...products_actions,
        ...producttypes_actions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandCategoryPage);



// WEBPACK FOOTER //
// ./src/pages/brands/BrandCategoryPage.jsx